export class verificationClientKeyIdRequest {
    clientKey: string;
    nickName: string;
}